import React, { useState, useRef, useCallback } from 'react';
import { motion } from 'framer-motion';
import './HeroNew.css';

const Hero = ({ navigateTo }) => {
  const heroRef = useRef(null);
  const [mouse, setMouse] = useState({ x: 0, y: 0 });

  const handleMouseMove = useCallback((e) => {
    const rect = heroRef.current.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    setMouse({
      x: (e.clientX - cx) / (rect.width / 2),   // -1 to 1
      y: (e.clientY - cy) / (rect.height / 2),
    });
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <>

      {/* Hero Section */}
      <section id="home" className="hero-section" ref={heroRef} onMouseMove={handleMouseMove} onMouseLeave={() => setMouse({ x: 0, y: 0 })}>
        {/* Background avec image */}
        <div className="hero-background">
          <div className="hero-image-overlay"></div>
          <img
            src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=2340&q=80"
            alt="Immeuble commercial moderne à Montréal – Ingénierie structurale DHR Structures"
            className="hero-image"
          />
        </div>

        <div className="hero-content">
          <div className="hero-container">
            <div className="hero-layout">
              <div className="hero-text">
                <motion.div
                  initial={{ opacity: 0, x: -40 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.9, delay: 0.3 }}
                  className="hero-eyebrow"
                >
                  <span className="eyebrow-line"></span>
                  <span className="eyebrow-text">DHR Structures</span>
                  <span className="eyebrow-dot"></span>
                </motion.div>

                <motion.h1
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.5 }}
                  className="hero-title"
                >
                  EXPERTISE STRUCTURALE<br />
                  <span className="highlight-text">INTÉGRALE</span>
                </motion.h1>

                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.7 }}
                  className="hero-actions"
                >
                  <button
                    className="cta-primary"
                    onClick={() => scrollToSection('about')}
                  >
                    Découvrir notre expertise
                  </button>
                  <button onClick={() => navigateTo('services')} className="cta-secondary">
                    Voir nos services
                  </button>
                </motion.div>
              </div>

              {/* Floating Brand Logo */}
              <motion.div
                className="hero-brand"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.4, delay: 0.6, ease: 'easeOut' }}
              >
                <div
                  className="hero-logo-3d"
                  style={{ transform: `perspective(800px) translate3d(${mouse.x * 14}px, ${mouse.y * 10}px, 0) rotateY(${mouse.x * 8}deg) rotateX(${-mouse.y * 6}deg)` }}
                >
                  <img
                    src="/images/logo-dhr-nobackrgound.png"
                    alt="DHR Structures"
                    className="hero-logo-brand"
                  />
                </div>
              </motion.div>
            </div>
          </div>
        </div>

      </section>


    </>
  );
};

export default Hero;